import { getAnalyticsConsent } from './analytics-consent-storage';
import { flushPendingMetaEvents } from './meta-events';

const META_PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID || '2022021558698703';

let analyticsLoaded = false;

interface MetaPixelFn {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
  push?: MetaPixelFn;
}

declare global {
  interface Window {
    fbq?: MetaPixelFn;
    _fbq?: MetaPixelFn;
  }
}

function appendScriptOnce(id: string, src: string): void {
  if (document.getElementById(id)) return;

  const script = document.createElement('script');
  script.id = id;
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
}

function loadMetaPixel(): void {
  if (!window.fbq) {
    const fbq: MetaPixelFn = function metaPixel(...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
      } else {
        fbq.queue?.push(args);
      }
    };

    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
  }

  appendScriptOnce(
    'meta-pixel-fbevents',
    'https://connect.facebook.net/en_US/fbevents.js',
  );

  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
  flushPendingMetaEvents();
}

export function loadAnalytics(): void {
  if (analyticsLoaded) return;
  analyticsLoaded = true;

  loadMetaPixel();
}

export function loadAnalyticsIfConsented(): void {
  if (getAnalyticsConsent() === 'granted') {
    loadAnalytics();
  }
}
